import { getUserAgentId } from '../shared/helper-utils/localStorage';
import { doPost } from './apiUtils';

export const getTboInsurancePlans = async (request) => {
  try {
    const req = {
      opid: 'RQ000',
      actioncode: 'GETTBOINSURANCEPLANS',
      resultformat: 'JSON',
      ...request,
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};

export const issueTboInsuranceApi = async (
  paymentmode,
  traceid,
  resultindex,
  paxList,
  pgname = '',
  bankid = '',
) => {
  try {
    const req = {
      opid: 'TRAWELLTAGAPI',
      actioncode: 'ISSUETBOINSURANCEPOLICY',
      resultformat: 'JSON',
      paymentmode,
      traceid,
      resultindex,
      paxList: JSON.stringify({ passengers: paxList }),
      pgname,
      bankid,
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};

export const cancelTboInsuranceApi = async (txid) => {
  const agentid = getUserAgentId();
  try {
    const req = {
      opid: 'CANCELINSURANCEPOLICY',
      actioncode: 'CANCELINSURANCE',
      txid,
      agentid,
      resultformat: 'JSON',
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};
